import $ from 'jquery'

$( document ).on( 'cartzillagb_brands_block_output_success', function( e, el, response, attributes ) {
    if( attributes.enableCarousel && $( `#${attributes.blockId}` ).length && typeof $( `#${attributes.blockId}` ).data( 'data-slick' ) !== undefined && $( `#${attributes.blockId}` ).find( '.js-slick-carousel' ).length ) {
        $( `#${attributes.blockId}` ).find( '.js-slick-carousel' ).slick()
        $( `#${attributes.blockId}` ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true );
        $( `#${attributes.blockId}` ).find( '.js-slick-carousel' ).slick( 'refresh' );
    }
})